import Vue from "vue";
import VueRouter from "vue-router";
import LoginComponent from "../components/auth/LoginComponent.vue";
import ConfirmComponent from "../components/auth/ConfirmComponent.vue";
import LandingPageView from "../views/LandingPageView.vue";
import cognitoAuth from "@/cognito";
import CallbackComponent from "../components/auth/CallbackComponent.vue";
import config from "@/config/index";
var imports = [];

let promiseList = [];
for (let i = 0; i < config.Sites.length; i++) {
  promiseList.push(import(`@/sections/${config.Sites[i]}/config/index`));
}
Promise.all(promiseList).then((data) => {
  data.forEach((module) => {
    imports[module.default.url] = module.default;
  });
  for (const [key, value] of Object.entries(imports)) {
    value.routes.forEach((route) => {
      route.path = "/" + value.url + route.path;
      route.name = `${value.url}-${route.name}`;
      route.beforeEnter = requireAuth;
      router.addRoute(route);
    });
  }
});

Vue.use(VueRouter);
const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginComponent,
  },
  {
    path: "/confirm",
    name: "Confirm",
    component: ConfirmComponent,
  },
  {
    path: "/",
    name: "Home",
    component: LandingPageView,
    beforeEnter: requireAuth,
  },
  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: CallbackComponent,
  },
];

var router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.name) {
      let title = to.name.split("-");
      document.title = `${title[1].replace("_", " ")} | ${title[0][0].toUpperCase() + title[0].slice(1)}`;
    } else {
      document.title = "Voice Management";
    }
  });
});

function HasGroup(userGroups = [], allowedGroups = []) {
  for (const userGroup of userGroups) {
    if (allowedGroups.includes(userGroup)) return true;
  }
  return false;
}

function requireAuth(to, from, next) {
  cognitoAuth.isAuthenticated((details, loggedIn) => {
    if (!loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      const groups = details.idToken.payload["cognito:groups"];
      to.params.groups = groups;
      to.params.name = details.idToken.payload["name"];
      to.params.email = details.idToken.payload["email"];
      if (!to.meta.allowedGroups || HasGroup(groups, to.meta.allowedGroups)) {
        next();
      } else {
        //No permission
        next({
          path: "/",
        });
      }
    }
  });
}

export default router;
